import { render, staticRenderFns } from "./DigicoopGCashSuccessPageComponent.vue?vue&type=template&id=23b29f82&scoped=true&"
import script from "./DigicoopGCashSuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./DigicoopGCashSuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./DigicoopGCashSuccessPageComponent.vue?vue&type=style&index=0&id=23b29f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b29f82",
  null
  
)

export default component.exports